import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Home } from './areas/home/Home';
import {ShipmentDetails} from './areas/shipmentDetails/ShipmentDetails';
import { PageNotFound } from './areas/pageNotFound/PageNotFound';
import { useChrLdFlag } from '@chr/common-launchdarkly';

export const AppRoutes = () => {
  const enhancedSearch = useChrLdFlag('enhanced-externaltracking-search', false);

  return (
    <Switch>
      {/* Redirect for requests coming from online.chrobinson.com/tracking */}
      <Redirect exact from="/:shipmentNumber" to="/detail/:shipmentNumber" />
      <Route
        exact={true}
        path="/"
        component={Home}
      />
      <Route
        exact={true}
        path="/detail/:shipmentNumber"
        component={ShipmentDetails}
      />
      {enhancedSearch && (
        <Route
          exact={true}
          path="/detail/:referenceNumber"
          component={ShipmentDetails}
        />
      )}
      <Route component={PageNotFound} />
    </Switch>
  );
};
